var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenRegularIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#377137;}.cls-3{fill:#66bc46;}.cls-4{fill:#172417;}.cls-5{fill:#131a13;}.cls-6{fill:#28572a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,230.27C517.13,227.92,318.89,21.82,311,13.49c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.64-10.79,3.09-14.29-.79-14.29-.79s-4-5.24-17.63-1.29C233.58,13.87,7.86,71.23,7.86,71.23S.77,73.05.69,80.31,0,125.07,0,125.07,195.25,376.45,202.91,386.41c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,232.38,519.39,230.27Zm-98.15-58-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L423.08,165C425.73,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.58,185.58c-1.89-2-167.08-173.72-173.7-180.65-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.92-.66-11.92-.66S269-1.86,257.6,1.43C244.4,5.24,56.3,53,56.3,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3,162.71,209.48,169.1,217.78c5.22,6.83,18.36,2.08,18.36,2.08S473.94,232,479.45,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S484.22,187.34,482.58,185.58Zm-61.34-13.32-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L423.08,165C425.73,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480,182.73S315.5,11.75,308.88,4.81c-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.92-.66-11.92-.66S269-2,257.6,1.31C244.4,5.12,56.3,52.93,56.3,52.93s-8.71,3-3.6,9.42L101.31,126s107.5,135.24,115.54,145.29S240,275.17,240,275.17s227.06-77.39,237.78-81S480,182.73,480,182.73Zm-58.72-10.47-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L423.08,165C425.73,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "241.66 281.15 241.66 308.67 474.48 224.48 474.48 201.17 241.66 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "474.48 201.17 458.13 206.84 474.48 224.48 474.48 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.61,15.61,0,0,0,228.6,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,182.73S409.43,109.41,358.89,56.84l-4.08,1.74L482.22,191.4C485.25,187.57,480,182.73,480,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.54,58.53c-8.47,2.19-26.71,8.67-16.63,21.56s24.93,13.26,42.41,8.43,132.73-36.46,143.9-39.6,25.71-9.77,12.89-21.8-30.41-8.71-44.76-4.92S125,56.33,116.54,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317,13.22l-2-2L289.9,17.92a30.42,30.42,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.33,70.72,64.64,78.07l1.92,2.51,25.8-6.91A9.44,9.44,0,0,1,92.33,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.16,17.6l-2-2-22.27,6a29,29,0,0,1,2.45,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.15,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,93,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.5,27.77l21.74-5.92-1.93-2L301.7,25.69c.32.33.64.67.95,1S303.22,27.42,303.5,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.13,81.29,72.07,87.8,74,90.29,98.14,83.7c-.47-.53-1-1.08-1.42-1.65C96.51,81.79,96.33,81.54,96.13,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.79,92.56l1.94,2.49,25.17-6.89c-.88-.69-1.74-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.33,26.1l-1.93-2-22.24,6.05a16.87,16.87,0,0,1,1.17,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.13,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,307.13,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M429.19,165.28,329.59,59.9a16.47,16.47,0,0,0-14.85-4.11L131.2,107.29c-4.77,1.34-6.13,5.59-3,9.44L222.5,233.88a14,14,0,0,0,14.18,4.17l190.15-63.39C431.53,173.1,432.59,168.87,429.19,165.28Zm-7.95,7-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L423.08,165C425.73,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,217.59c-3.12-1.08-3.1-2.79,0-3.82l22.32-7.3c3.14-1,5.27.8,4.74,4.06l-1.55,9.58a4.89,4.89,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRegularIsometric);
export default __webpack_public_path__ + "static/media/green-regular-isometric.baa26885488896534ebcfd311fd30a18.svg";
export { ForwardRef as ReactComponent };